/* eslint-disable react-hooks/exhaustive-deps */
import {useEffect} from 'react'
import {ConfirmationModal} from '../../../../components/ConfirmationModal'
import useInStockNotifyOperations from '../../hooks/useInStockNotifyOperations'
import InquiryDetailsTable from '../table/InquiryDetailsTable'

interface IInquiryDetailsModalProps {
  onClose: () => void
  row: any
  isParentRow: boolean
}

const InquiryDetailsModal = ({onClose, row, isParentRow}: IInquiryDetailsModalProps) => {
  const {productVariants, isOperationLoading, getInquiryDetails} = useInStockNotifyOperations()

  useEffect(() => {
    getInquiryDetails(row?.parent_sku, !isParentRow ? row?.sku : undefined)
  }, [row?.parent_sku, isParentRow])

  return (
    <ConfirmationModal
      show={true}
      onClose={onClose}
      title={row.product_title}
      disableFooter={true}
      dialogClassName='mw-1000px'
      body={
        <InquiryDetailsTable
          isParentRow={isParentRow}
          productVariants={productVariants}
          isOperationLoading={isOperationLoading}
        />
      }
    />
  )
}

export default InquiryDetailsModal
